export default __webpack_public_path__ + "static/media/meteors.9edd22c5.png";